/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import parser from '../config/parser';
import rowConfig from '../config/rowConfig';
import { IComparisonCompaniesTableData, UseComparisonCompaniesTableDataProps } from '../types';

const useComparisonCompaniesTableData = ({ data, format }: UseComparisonCompaniesTableDataProps) => {
  const [columns, setColumns] = useState<any[]>();
  const [spreadsheet, setSpreadsheet] = useState<SpreadsheetConfig>();

  const config = useMemo(() => rowConfig({ companies: data?.current_value }), [data?.current_value]);
  
  const createMetricColumn = (metricKey: keyof IComparisonCompaniesTableData) =>
    data?.current_value?.reduce(
      (prev, current) => ({ ...prev, [`company-${current.name}`]: current[metricKey] }),
      {}
    ) ?? {};

  useEffect(() => {
    if (data?.current_value?.length) {
      setColumns([
        createMetricColumn('ticker_symbol'),
        createMetricColumn('ltm_revenue'),
        createMetricColumn('ltm_revenue_growth'),
        createMetricColumn('ntm_revenue'),
        createMetricColumn('ntm_revenue_growth'),
        createMetricColumn('ltm_ebitda'),
        createMetricColumn('ntm_ebitda'),
        createMetricColumn('gross_margin'),
        createMetricColumn('ebitda_margin'),
        createMetricColumn('tangible_book_value'),
        createMetricColumn('net_income')
      ]);
    }
  }, [data?.current_value]);

  const tableTerms: any = useMemo(
    () => ({
      tableName: 'Performance Metrics',
      tableSlug: 'comparison-companies',
    }),
    []
  );

  useEffect(() => {
    if (columns && tableTerms) {
      const spreadsheetConfig = new SpreadsheetConfig({
        parser,
        rowConfig: config,
        name: 'ComparisonCompanies',
        columns,
        tableData: { columns },
        tableTerms,
        showTotalColumn: false,
        showToolbar: true,
        showPreviousColsDivider: true,
        hasColTitle: true,
        allowConfirmAndDeleteColumn: false,
        currencyFormatter: true,
        unitsFormatter: true,
        totalParser: undefined,
        alwaysDisplayLegend: false,
        format,
      });      

      setSpreadsheet(spreadsheetConfig);
    }
  }, [columns, tableTerms]);

  return {
    spreadsheet,
  };
};

export default useComparisonCompaniesTableData;
